import React, { PropsWithChildren } from "react";

interface HeadingProps {
  level: "h1" | "h2" | "h3" | "h4" | "h5";
  className?: string;
}

const Heading = ({
  level = "h1",
  children,
  className
}: PropsWithChildren<HeadingProps>) => {
  const TsHeading = ({ ...props }: React.HTMLAttributes<HTMLHeadingElement>) =>
    React.createElement(level, props, children);

  return <TsHeading className={className}>{children}</TsHeading>;
};

export default Heading;
